import { render, staticRenderFns } from "./FireReportBarChart.vue?vue&type=template&id=6b80fea1&scoped=true&"
import script from "./FireReportBarChart.vue?vue&type=script&lang=js&"
export * from "./FireReportBarChart.vue?vue&type=script&lang=js&"
import style0 from "./FireReportBarChart.vue?vue&type=style&index=0&id=6b80fea1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b80fea1",
  null
  
)

export default component.exports